<template>
  <v-dialog v-model="dialog" max-width="800">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="primary" dark class="text-capitalize mb-2" v-bind="attrs" v-on="on">
        {{ $t('createCourse') }}
      </v-btn>
    </template>

    <v-card>
      <v-card-title>
        <span class="headline">{{ $t('createCourse') }}</span>
      </v-card-title>

      <v-card-text>
        <v-form ref="form">
          <v-row>
            <!-- Course Title -->
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="course.title"
                :label="$t('title')"
                :rules="[rules.required]"
                clearable
              ></v-text-field>
            </v-col>

            <!-- Job Title -->
            <!-- <v-col cols="12" sm="6">
              <v-select
                v-model="course.jobTitle"
                :items="jobTitles"
                :label="$t('jobTitle')"
                :rules="[rules.required]"
                item-text="name"
                item-value="name"
              ></v-select>
            </v-col> -->

            <!-- Category -->
            <v-col cols="12" sm="6">
              <v-select
                v-model="course.category"
                :items="categories"
                :label="$t('category')"
                :rules="[rules.required]"
                item-text="name"
                item-value="id"
              ></v-select>
            </v-col>

            <!-- Description -->
            <v-col cols="12">
              <v-textarea
                v-model="course.description"
                :label="$t('description')"
                :rules="[rules.required]"
                clearable
                rows="3"
                auto-grow
              ></v-textarea>
            </v-col>

            <!-- Thumbnail Upload -->
            <v-col cols="12">
              <v-file-input
                v-model="thumbnailFile"
                :label="$t('thumbnail')"
                accept="image/*"
                prepend-icon="mdi-camera"
                @change="handleThumbnailChange"
                show-size
                :rules="[rules.imageSize]"
              >
                <template v-slot:selection="{ text }">
                  <v-chip
                    small
                    label
                    color="primary"
                  >
                    {{ text }}
                  </v-chip>
                </template>
              </v-file-input>
            </v-col>

            <!-- Thumbnail Preview -->
            <v-col v-if="thumbnailPreview" cols="12" class="text-center">
              <v-img
                :src="thumbnailPreview"
                max-height="200"
                contain
                class="grey lighten-2"
              ></v-img>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="close">
          {{ $t('cancel') }}
        </v-btn>
        <v-btn 
          color="blue darken-1" 
          text 
          @click="saveNewCourse"
          :loading="saving"
        >
          {{ $t('save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'CourseForm',
  data() {
    return {
      dialog: false,
      saving: false,
      thumbnailFile: null,
      thumbnailPreview: null,
      rules: {
        required: (value) => !!value || this.$t('required'),
        imageSize: (file) => {
          if (!file) return true;
          const size = file.size / 1024 / 1024; // Convert to MB
          return size <= 2 || this.$t('imageSizeLimit');
        },
      },
      course: {
        title: '',
        description: '',
        category: null,
        jobTitle: null,
        thumbnail: null,
        addedBy: parseInt(localStorage.getItem('loggedUserId')),
      },
      categories: [],
      jobTitles: [],
    };
  },
  created() {
    this.fetchCategories();
    this.fetchJobTitles();
  },
  methods: {
    fetchCategories() {
      this.$store
        .dispatch('course/fetchCategories')
        .then((response) => {
          this.categories = response.data;
        })
        .catch((error) => {
          console.error('Error fetching categories:', error);
          this.$router.push({ name: 'NoInternet' });
        });
    },
    fetchJobTitles() {

      // hard coded job titles
      this.jobTitles = [
        { id: 1, name: 'Software Engineer' },
        { id: 2, name: 'Data Scientist' },
        { id: 3, name: 'Product Manager' },
        { id: 4, name: 'UX Designer' },
        { id: 5, name: 'DevOps Engineer' },
        { id: 6, name: 'QA Engineer' },
        { id: 7, name: 'Technical Writer' },
        { id: 8, name: 'Scrum Master' },
        { id: 9, name: 'Business Analyst' },
        { id: 10, name: 'Systems Analyst' },
      ];

    },
    handleThumbnailChange(file) {
      if (!file) {
        this.thumbnailPreview = null;
        return;
      }

      // Create preview
      this.thumbnailPreview = URL.createObjectURL(file);
      
      // Clean up the old preview URL
      return () => {
        URL.revokeObjectURL(this.thumbnailPreview);
      };
    },
    async saveNewCourse() {
      if (this.$refs.form.validate()) {
        this.saving = true;
        
        try {
          // Handle thumbnail upload if exists
          if (this.thumbnailFile) {
            const formData = new FormData();
            formData.append('thumbnail', this.thumbnailFile);
            
            const uploadResponse = await this.$store.dispatch('course/uploadCourseThumbnail', formData);
            this.course.thumbnail = uploadResponse.data.dbPath;
          }

          // Save course
          console.log('Course:', this.course);
          const response = await this.$store.dispatch('course/createCourse', this.course);
          this.$root.$emit('message_from_parent', this.$t(response.data.responseMsg));
          this.dialog = false;
          this.$emit('courseAdded');

          this.resetForm();
          
        } catch (error) {
          console.error('Error creating course:', error);
          this.$router.push({ name: 'NoInternet' });
        } finally {
          this.saving = false;
        }
      }
    },

    // Add this new method to properly reset the form
    resetForm() {
      this.$refs.form.reset();
      this.thumbnailPreview = null;
      this.thumbnailFile = null;
      this.course = {
        title: '',
        description: '',
        category: null,
        jobTitle: null,
        thumbnail: null,
        addedBy: parseInt(localStorage.getItem('loggedUserId')),
      };
    },
    close() {
      this.dialog = false;
      this.$refs.form.reset();
      this.thumbnailPreview = null;
      this.thumbnailFile = null;
    },
  },
  beforeDestroy() {
    // Clean up any remaining object URLs
    if (this.thumbnailPreview) {
      URL.revokeObjectURL(this.thumbnailPreview);
    }
  },
};
</script>